import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { ICompanyBase } from '../../../types'
import { ProfileCard } from '../ProfileCard'
import { getCompanyLogo } from '../../../utils'

type Props = {
  item: ICompanyBase
  shouldDisplayInvestorType?: boolean
}

export const VCCard: FC<Props> = ({ item, shouldDisplayInvestorType = false }) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  return (
    <ProfileCard
      avatar={getCompanyLogo(item)}
      name={item.name}
      // 現状 status が published の会社しか item に入ることはないが、今後 closed な会社が入る可能性があるので href に条件を記載した
      href={item.status === 'published' ? `/companies/${item.slug}` : ''}
    >
      {shouldDisplayInvestorType && <div className={styles.vc}>{t('ベンチャーキャピタル')}</div>}
      {item.hasInvestmentsWithJobs && <div className={styles.job}>{t('投資先求人あり')}</div>}
      <p className={styles.text}>{item.aboutUs}</p>
    </ProfileCard>
  )
}
